import React, { useState } from "react"
import Button from "../Button"
import { IButtonHelp } from "./interface"
import { ContainerIcon, Container, ContainerOptions, NameOption, ButtonOption } from "./style"
import hint from "../../assets/icons/hintHover.svg"

const ButtonHelper = ({
    options
}: IButtonHelp
): React.ReactElement=> {
    const [showList, setShowList] = useState(false)

    const handleShow = () => setShowList(!showList)
    const handleOption = () => setShowList(false)

    const optionsList = () => {
        return (
            <ContainerOptions>
                {
                    options.map((item) => {
                        return (
                                <ButtonOption onClick={() => {
                                    setTimeout(() => {}, 1000)
                                    handleOption()
                                    item.function()
                                }}>
                                    <NameOption>
                                        { item.name }
                                    </NameOption>
                                    <ContainerIcon>
                                        <img src={item.icon ?? hint} className="icon-hint" />
                                    </ContainerIcon>
                                </ButtonOption>
                        )
                    })
                }
            </ContainerOptions>
        )
    }

    return (
        <>
            <Container>
                {
                    showList && optionsList()
                }
                <Button className="button" onClick={handleShow}>
                {showList ? "X" : "?"}
                </Button>
            </Container>
        </>
    )
}

export default ButtonHelper